import axios from 'axios';

import { getData } from '@feature/utils';

import {
  TravelAggregates,
  TravelRegistryExportRequest,
  TravelRegistryPage,
  TravelRegistryParams,
  TravelReportingParams,
  TravelStaffSummaryExportRequest,
  TravelYearlyAggregatesParams,
  WORLD_TOPOLOGY_URL,
  WorldTopology,
} from './TravelRegistryTypes';

export function getPaged(params: TravelRegistryParams) {
  return axios
    .get<TravelRegistryPage>('/travel/registry/paged', {
      params,
    })
    .then(getData);
}

export function exportRegistry(params: TravelRegistryExportRequest) {
  return axios.get<Blob>('/travel/registry/export', { responseType: 'blob', params });
}

export function exportStaffSummary(params: TravelStaffSummaryExportRequest) {
  return axios.get<Blob>('/travel/registry/staff-summary/export', { responseType: 'blob', params });
}

export function getAggregates(params: TravelReportingParams) {
  return axios
    .get<TravelAggregates>('/travel/registry/aggregates', {
      params,
    })
    .then(getData);
}

export function getYearlyAggregates(params: TravelYearlyAggregatesParams) {
  return axios
    .get<TravelAggregates[]>('/travel/registry/aggregates/yearly', {
      params,
    })
    .then(getData);
}

// A static asset rather than an endpoint, so it goes around axios and its /api base URL.
export function getWorldTopology(): Promise<WorldTopology> {
  return fetch(WORLD_TOPOLOGY_URL).then(response => {
    if (!response.ok) {
      throw new Error(`${WORLD_TOPOLOGY_URL} responded ${response.status}`);
    }
    return response.json();
  });
}
